import React, {useEffect, useState} from "react"
import {useLocation, useNavigate} from "react-router-dom"
// Components
import {RangesEditor} from "@/components/Ranges";
import {BuilderShell, SectionCard} from "@/components/Layout";
// Translation
import {useTranslation} from "react-i18next";
// Data
import {useData} from "@/context/PackagingDataProvider";

export default function RangeBuilder(props: any) {

    const location = useLocation();
    const redirect = useNavigate()

    const {creating, editing} = props
    const {createAny, editAny, getLogo, brands, getBrands} = useData()
    const {t} = useTranslation(["ranges", "common"])

    // Data
    const [range, setRange] = useState<any>({
        brand: "",
        id: "",
        name: "",
        description: "",
        logo: "",
        logo_id: "",
    })

    useEffect(() => {
        // Fetch brands if not already done
        if (!brands) getBrands()

        if (editing) {
            let editedRange = location.state
            let editedRangeLogo: any = undefined

            if (!!editedRange.logo_id) {
                getLogo(editedRange.logo_id).then((logo: any) => editedRangeLogo = logo)
            }

            setRange({
                brand: editedRange?.brand.id,
                id: editedRange?.id,
                name: editedRange?.name,
                description: editedRange?.description,
                logo: !!editedRangeLogo ? editedRangeLogo : "",
                logo_id: editedRange?.logo_id,
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    useEffect(() => {
        if (!!location && !!brands && !!brands.length && !editing) {
            const params = new URLSearchParams(location.search)
            setRange({...range, brand: params.get("brandid")})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, brands]);

    const handleCreateRange = () => {
        createAny(range, "range").then((created: any) => {
            if (created) redirect("/?tab=brands-ranges")
        })
    }

    const handleEditRange = () => {
        editAny(range, "range").then((updated: any) => {
            if (updated) redirect("/?tab=brands-ranges")
        })
    }

    return (
        <BuilderShell
            backTo={"/?tab=brands-ranges"}
            backLabel={t("common:back")}
            title={editing ? t("range_editor") : t("range_creation")}
            subtitle={editing ? range.name : t("common:brands_ranges")}
            maxWidth={760}
        >
            <SectionCard>
                <RangesEditor
                    onCreate={() => handleCreateRange()}
                    onEdit={() => handleEditRange()}
                    {...{creating, editing, range, setRange, brands, t}}
                />
            </SectionCard>
        </BuilderShell>
    )
}
